import React from 'react'; 
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';

const AccountMenu = ({ context }) => {

    const restTypeCtx = () => context.restType;
    const restType = restTypeCtx();
        
    return (
    
		<div className="c-account-menu">
			
			<div className="l-block l-block--max-width l-block--no-padding">
			
				<div className="l-grid">
			
					<div className="l-grid__col">
					
						<div className="c-account-menu__inner">
						
							{restType === 'account' &&
								<Link to={{ pathname: '/account/' }} className="c-account-menu__tab state-active">Account</Link>
							}
							{restType !== 'account' &&
								<Link to={{ pathname: '/account/' }} className="c-account-menu__tab">Account</Link>
							}
							
							{restType === 'details' &&
								<Link to={{ pathname: '/account/details/' }} className="c-account-menu__tab state-active">Details</Link>
							}
							{restType !== 'details' &&
								<Link to={{ pathname: '/account/details/' }} className="c-account-menu__tab">Details</Link>
							}
							
							{restType === 'requests' &&
								<Link to={{ pathname: '/account/quote-requests/' }} className="c-account-menu__tab state-active">Quote Requests</Link>
							}
							{restType !== 'requests' &&
								<Link to={{ pathname: '/account/quote-requests/' }} className="c-account-menu__tab">Quote Requests</Link>
							}
						
						</div>
						
					</div>
		
				</div>
		
			</div>
		
		</div>
		
	)
};
export default WithConsumer(AccountMenu);